import React from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled, {css} from 'styled-components';
import Button from '../Button';
import {
    breakpoints,
    Flex,
    mobileMediaQuery,
    notWebMediaQuery,
    tabletMediaQuery,
    useBreakpoint,
} from '../../styles';

import ErrorHero from '../../assets/error-hero.png';
import GlobImage from '../../assets/glob.png';
import StarBackground from '../../assets/star_background_tablet.png';
import {debugCNitoUrl, useIsCartoonito} from '../../helpers';
import {ReactComponent as RefreshIcon} from '../../assets/ic_refresh.svg';

export const ErrorContainer = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const isCartoonito = useIsCartoonito();
    const breakpoint = useBreakpoint();

    const handleRetry = () => {
        history.replace(`/home${debugCNitoUrl()}`);
    };

    return (
        <Container cnito={isCartoonito}>
            {isCartoonito && ['xs', 'mobile', 'sm'].includes(breakpoint) ? (
                <>
                    <img
                        width="42%"
                        height="auto"
                        src={isCartoonito ? GlobImage : ErrorHero}
                        alt=""
                    />
                    <Flex>
                        <h1>
                            {t(`error${isCartoonito ? '.cnito' : ''}.title`)}
                        </h1>
                        {!isCartoonito && (
                            <p>
                                {t(
                                    `error${
                                        isCartoonito ? '.cnito' : ''
                                    }.subtitle`,
                                )}
                            </p>
                        )}

                        {isCartoonito && (
                            <p>
                                {t(
                                    `error${
                                        isCartoonito ? '.cnito' : ''
                                    }.subtitle`,
                                )}
                            </p>
                        )}
                        <Button
                            cnito={isCartoonito}
                            light={!isCartoonito}
                            onClick={handleRetry}
                            value={t('error.cta')}
                        />
                    </Flex>
                </>
            ) : (
                <>
                    <h1>{t(`error${isCartoonito ? '.cnito' : ''}.title`)}</h1>
                    {!isCartoonito && (
                        <p>
                            {t(`error${isCartoonito ? '.cnito' : ''}.subtitle`)}
                        </p>
                    )}
                    <img
                        width="42%"
                        height="auto"
                        src={isCartoonito ? GlobImage : ErrorHero}
                        alt=""
                    />
                    {isCartoonito && (
                        <p>
                            {t(`error${isCartoonito ? '.cnito' : ''}.subtitle`)}
                        </p>
                    )}
                    <Button
                        cnito={isCartoonito}
                        light={!isCartoonito}
                        onClick={handleRetry}
                    >
                        {t('error.cta')}
                        <RefreshIcon marginLeft="10px" />
                    </Button>
                </>
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: auto;

    h1 {
        margin: 0 0 12px 0;
        text-transform: initial;
        font-size: 45px;
        font-weight: bold;
        line-height: 56px;
        text-align: center;
    }

    p {
        margin: 0 0 19.5px 0;
        font-size: 18px;
        line-height: 30px;
        text-align: center;
    }

    img {
        margin-bottom: 25.5px;
        object-fit: contain;
        max-height: 257px;
        max-width: 607px;
    }

    svg {
        margin-left: 10px;
    }

    ${notWebMediaQuery} {
        padding-top: 78px;
    }

    ${props =>
        props.cnito &&
        css`
            background-color: #32bf5e;
            padding-top: 82px;
            padding-bottom: 72px;
            flex: 1;
            color: #000;
            background-image: url(${StarBackground});
            background-size: contain;

            ${notWebMediaQuery} {
                padding-top: 142px;
            }

            h1 {
                font-family: 'Rodger';
                font-weight: 900;
                font-size: 24px;
                line-height: 31px;
                margin: 0;
                text-transform: uppercase;
            }

            p {
                font-size: 18px;
                line-height: 24px;
                font-family: 'AvenirNextRoundedStd';
                font-weight: 600;
                margin: 0 0 32px 0;

                ${mobileMediaQuery} {
                    font-size: 16px;
                    margin: 0 0 24px 0;
                }

                ${tabletMediaQuery} {
                    max-width: 300px;
                }
            }

            img {
                margin: 40px 0;
                max-height: 235px;
                max-width: 240px;

                @media screen and (max-width: ${breakpoints.sm}px),
                screen and (max-height: ${breakpoints.sm}px) {
                    max-height: 209px;
                    max-width: 213px;
                    margin: auto 104px auto 0;
                }
            }

            @media screen and (max-width: ${breakpoints.sm}px),
            screen and (max-height: ${breakpoints.sm}px) {
                padding-top: 142px;
                flex-direction: row;
                justify-content: center;

                ${Flex} {
                    max-width: 265px;
                }
            }
        `}
`;
